import { createRequestDeduper } from "@/utils/keyed-work";
import type { Component } from "solid-js";

export type ControlRouteModule = { default: Component };

const routeLoaders = {
  providers: () => import("@/pages/providers") as Promise<ControlRouteModule>,
  usage: () => import("@/pages/usage") as Promise<ControlRouteModule>,
  automations: () => import("@/pages/automations") as Promise<ControlRouteModule>,
  tools: () => import("@/pages/tools") as Promise<ControlRouteModule>,
  settings: () => import("@/pages/settings") as Promise<ControlRouteModule>,
};

export type ControlRoute = keyof typeof routeLoaders;

const pending = createRequestDeduper<ControlRoute, ControlRouteModule>({ retainSuccess: true });

export function loadControlRoute(route: ControlRoute) {
  return pending.run(route, routeLoaders[route]);
}

export function preloadControlRoute(route: ControlRoute) {
  void loadControlRoute(route).catch(() => undefined);
}
